export const RESET = 'RESET_FUNDRAISER';
export const SET_STATUS = 'SET_FUNDRAISER_STATUS'
export const SET_CHALLENGE_STATUS = 'SET_FUNDRAISER_CHALLENGE_STATUS'
export const SET_CHALLENGES = 'SET_FUNDRAISER_CHALLENGES'


export const SET_TEAM = 'SET_FUNDRAISER_TEAM'
export const SET_CHALLENGE = 'SET_FUNDRAISER_CHALLENGE'

